
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22 6v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V6h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H20a2 2 0 012 2zM7 4.5a.5.5 0 00-.5-.5H4a2 2 0 00-2 2v2.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V6h2.5a.5.5 0 00.5-.5v-1zM21.5 15h-1a.5.5 0 00-.5.5V18h-2.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H20a2 2 0 002-2v-2.5a.5.5 0 00-.5-.5zM7 18.5a.5.5 0 00-.5-.5H4v-2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V18a2 2 0 002 2h2.5a.5.5 0 00.5-.5v-1z","fill":"#000"}})])
          )
        }
      }
    